import styled from 'styled-components';

export const Container = styled('div')`
  width: 100%;
  height: 100;
    
  .inputText{
    background-color: ${(props) => props.theme.colors.modalInputSearchBackgroundColor};
  }
  .collapsible-body{
    height: 263px !important;
  }

  .texto-carregamento{
      color: #610082;
  }

  .config-wrapper {
      width: 100%;
      height: 100;

      .pergunta-principal-wrapper {
          margin-bottom: 17px;

          .pergunta-principal-text-wrapper{
              background-color: #F5F6FA;
              border-radius: 18px;
              padding: 10px 20px 10px 20px;
              font-weight: bold;

              .pergunta-principal-text {
                  color: #610082;
                  font-size: 1.2rem;
              }
          }
      }

      .titulo-wrapper{
          margin-bottom: 20px;
      }

      .label-wrapper{
          margin-bottom: 18px;
      }

      .label-text{
          color: ${(props) => props.theme.simpleCrossConfig.labelTextColor};
          font-size: 1.4rem;
          display: block;
      }
  }
`;
